<template>
  <div
    :class="[klass, 'oval-button', isInactive ? 'inactive' : '', notAllowed ? 'not-allowed' : '']"
    @click="clicked"
  >
    <div class="text" v-if="!loading">
      {{text}}
    </div>
    <div v-if="loading">
      <Spinner />
    </div>

    <slot></slot>
  </div>
</template>

<script>
import Spinner from "./Spinner.vue"
export default {
  name: 'OvalButton',
  components: { Spinner },
  props: {
    isInactive: { type: Boolean, default: false },
    notAllowed: { type: Boolean, default: false },
    text: String,
    klass: String,
    onClick: { type: Function, default: function() {} },
    loading: { type: Boolean, default: false },
  },
  methods: {
    clicked: function() {
      if (!this.notAllowed) {
        this.onClick();
      }
    }
  }
}
</script>
<style lang="scss">
  div.oval-button {
    padding: 16px 32px;
    display: inline-block;
    width: auto;
    text-align: center;
    float: right;
    background: #5160EC;
    cursor: pointer;

    &.alert-button {
      background: #F1574B;
    }

    &.mobile-only {
      display: none;
    }

    .text {
      color: white;
      letter-spacing: 0.004375em;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
    }

    .loader {
      width: 16px;
      height: 16px;
    }
  }

  div.oval-button.small {
    float: none;
    padding: 8px 16px;
    height: auto;
    border-radius: 0;
    .text {
      color: white;
    }

    &.not-allowed {
      .text {
        color: white;
      }
      background-color: #CBCFF9;
    }
  }

  @media screen and (max-width: 768px) {
    div.oval-button {
      padding: 12px;

      &.desktop-only {
        display: none;
      }

      &.mobile-only {
        display: inline-block;
      }
    }
  }

  div.oval-button.inactive {
    background-color: white;
    border: 1px solid #5160EC;
    padding: 7px 15px !important;

    .text {
      color: #5160EC;
    }
  }

  .oval-button.not-allowed {
    background-color: #BFC7FF;
    cursor: not-allowed;
  }
</style>
